import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Eye } from "lucide-react";

const AgeingResults = () => {
  const { days } = useParams();
  const [loading, setLoading] = useState(true);
  const [patients, setPatients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // change if needed


useEffect(() => {
  setCurrentPage(1);
  fetchReport();
}, [days]);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `https://newerp.awasthivitality.com/api/patients/ageingdays/${days}`
      );
      const data = await res.json();
      setPatients(data.success && Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("API Error:", err);
      setPatients([]);
    } finally {
      setLoading(false);
    }
  };
const totalPages = Math.ceil(patients.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const paginatedPatients = patients.slice(startIndex, endIndex);

  return (
    <>
      {/* ✅ FIXED STYLES */}
      <style>{`
        .ageing-wrapper {
          margin-left: 260px;
        }

        @media (max-width: 992px) {
          .ageing-wrapper {
            margin-left: 0 !important;
          }
          .desktop-table {
            display: none !important;
          }
          .mobile-cards {
            display: block !important;
          }
        }

        @media (min-width: 993px) {
          .mobile-cards {
            display: none !important;
          }
        }

        /* ✅ Force left text alignment */
        .desktop-table table th,
        .desktop-table table td {
          text-align: left !important;
          vertical-align: middle;
        }

        /* Center only S.No column */
        .desktop-table table th:first-child,
        .desktop-table table td:first-child {
          text-align: center !important;
          width: 60px;
        }
      `}</style>

      <div className="ageing-wrapper">
        <div style={styles.page}>
          {/* Header */}
          <div style={styles.headerBar}>
<h2 style={{ color: "white" }}>🕒 Patient Ageing Report</h2>
            <span style={styles.countBadge}>{patients.length} Patients</span>
          </div>

          {loading ? (
            <p style={styles.loading}>Loading...</p>
          ) : (
            <>
              {/* ✅ DESKTOP TABLE */}
              <div className="desktop-table" style={styles.card}>
                <div style={{ overflowX: "auto" }}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>S.No.</th>
                        <th style={styles.th}>PR No</th>
                        <th style={styles.th}>Patient Name</th>
                        <th style={styles.th}>Mobile</th>
                        <th style={styles.th}>Ageing</th>
                        <th style={styles.th}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                  {paginatedPatients.length > 0 ? (
  paginatedPatients.map((p, i) => (
    <tr key={i} style={styles.tr}>
      <td style={styles.td}>
        {startIndex + i + 1} {/* ✅ correct serial */}
      </td>
      <td style={styles.td}>{p.pr_no}</td>
      <td style={styles.td}>{p.name}</td>
      <td style={styles.td}>{p.mobile}</td>
      <td style={styles.td}>
        <span style={styles.badge}>{p.ageing_days} Days</span>
      </td>
      <td style={styles.td}>
        <Eye
          size={18}
          style={styles.icon}
          onClick={() =>
            (window.location.href =
              `/patient/details/${p.patient_id}`)
          }
        />
      </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td style={styles.noData} colSpan="6">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* ✅ MOBILE CARDS */}
              <div className="mobile-cards">
          {paginatedPatients.length > 0 ? (
  paginatedPatients.map((p, i) => (
    <div key={i} style={styles.mobileCard}>

                      <div style={styles.mobileRow}>
                        <span style={styles.label}>PR No:</span>
                        <span style={styles.value}>{p.pr_no}</span>
                      </div>
                      <div style={styles.mobileRow}>
                        <span style={styles.label}>Name:</span>
                        <span style={styles.value}>{p.name}</span>
                      </div>
                      <div style={styles.mobileRow}>
                        <span style={styles.label}>Mobile:</span>
                        <span style={styles.value}>{p.mobile}</span>
                      </div>
                      <div style={styles.mobileRow}>
                        <span style={styles.label}>Ageing:</span>
                        <span style={styles.badge}>
                          {p.ageing_days} Days
                        </span>
                      </div>

                      <button
                        style={styles.viewBtn}
                        onClick={() =>
                          (window.location.href =
                            `/patient/details/${p.patient_id}`)
                        }
                      >
                        View Details
                      </button>
                    </div>
                  ))
                ) : (
                  <p style={styles.noData}>No records found</p>
                )}
              </div>
              {totalPages > 1 && (
  <div style={styles.pagination}>
    <button
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => prev - 1)}
      style={styles.pageBtn}
    >
      Prev
    </button>

    {Array.from({ length: totalPages }, (_, i) => i + 1)
      .filter(page =>
        page === 1 ||
        page === totalPages ||
        Math.abs(page - currentPage) <= 1
      )
      .map((page, i, arr) => (
        <React.Fragment key={page}>
          {i > 0 && page - arr[i - 1] > 1 && (
            <span style={styles.dots}>…</span>
          )}
          <button
            onClick={() => setCurrentPage(page)}
            style={{
              ...styles.pageBtn,
              background:
                currentPage === page ? "#2563eb" : "#fff",
              color:
                currentPage === page ? "#fff" : "#2563eb",
            }}
          >
            {page}
          </button>
        </React.Fragment>
      ))}

    <button
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage(prev => prev + 1)}
      style={styles.pageBtn}
    >
      Next
    </button>
  </div>
)}
            </>
          )}
        </div>
      </div>
    </>
  );
};


const styles = {
  page: {
    padding: "16px",
    background: "#f4f6f9",
    minHeight: "100vh",
  },

  headerBar: {
    background: "linear-gradient(135deg, #0dcaf0, #777e92ff)",
    padding: "14px 16px",
    borderRadius: "12px",
    color: "#fff",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },

  heading: {
    fontSize: "18px",
    fontWeight: "700",
  },

  countBadge: {
    background: "rgba(255,255,255,.15)",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
  },

  card: {
    background: "#fff",
    borderRadius: "14px",
    padding: "10px",
    boxShadow: "0 4px 18px rgba(0,0,0,.06)",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    background: "#f1f5f9",
    padding: "12px",
    textAlign: "left",
    fontWeight: "700",
    fontSize: "13px",
  },

  tr: {
    borderBottom: "1px solid #e5e7eb",
  },

  td: {
    padding: "12px",
    fontSize: "13px",
    textAlign: "left",
  },

  badge: {
    background: "#dbeafe",
    color: "#1d4ed8",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "700",
  },

  icon: {
    cursor: "pointer",
    color: "#2563eb",
  },

  mobileCard: {
    background: "#fff",
    borderRadius: "14px",
    padding: "14px",
    marginBottom: "12px",
    boxShadow: "0 4px 16px rgba(0,0,0,.06)",
  },

  mobileRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    flexWrap: "wrap",
    marginBottom: "6px",
    fontSize: "14px",
  },

  label: {
    color: "#6b7280",
    fontWeight: "600",
    textAlign: "left",
  },

  value: {
    fontWeight: "600",
    color: "#111827",
    textAlign: "left",
  },

  viewBtn: {
    marginTop: "10px",
    width: "100%",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    padding: "10px",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },

  noData: {
    textAlign: "center",
    padding: "20px",
    color: "#6b7280",
  },

  loading: {
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "600",
  },
  pagination: {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "6px",
  marginTop: "16px",
  flexWrap: "wrap",
},

pageBtn: {
  border: "1px solid #2563eb",
  background: "#fff",
  color: "#2563eb",
  padding: "6px 12px",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
},

dots: {
  padding: "0 6px",
  fontWeight: "700",
  color: "#6b7280",
},

};

export default AgeingResults;
